export default {
    remittance: {
        data: {},
        receiver: {
            distributorId: null,
            hubId: null,
            code: null,
            name: null,
            accountType: null,
        },
    },
};
